<template>
  <div v-if="response.message" class="response" :class="response.type">

    <span class="success" v-if="response.type === 'success'"><font-awesome-icon :icon="['fas', 'check']" /></span>
    <span class="error" v-if="response.type === 'error'"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>

    <span v-if="!response.errors.check">{{ _[response.message] || response.message }}</span>
    <span v-else>{{ response.errors.check.join(',') }}</span>

    <router-link v-if="type && type === 'session' && response.message === 'session_successfully_created' && response.type === 'success'" to="/session/create" class="button">
      {{ _.create_another_session }}
    </router-link>
    <router-link v-if="type && type === 'presentation' && response.message === 'presentation_successfully_created' && response.type === 'success'" to="/presentation/create" class="button">
      {{ _.create_another_presentation }}
    </router-link>
    <router-link v-if="type && type === 'person' && response.message === 'person_successfully_created' && response.type === 'success'" to="/person/create" class="button">
      {{ _.create_another_person }}
    </router-link>

    <span class="close" @click="clearResponse()"><font-awesome-icon :icon="['fas', 'times']" /></span>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    type: null,
  },
  methods: {
    ...mapMutations(['clearResponse'])
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/response';
.response > .button {
  color: inherit;
  text-decoration: none;
  background: rgba(0,0,0,.15);
  margin-left: 12px;
  padding: 4px 5px;
  border-radius: 4px;
  &:hover {
    background: rgba(0,0,0,.35);
  }
}
</style>
